import { useState, useEffect } from 'react';
import { useNavigate } from "react-router";
import { getDocumentUrl } from '../../../functions/storageUtils';
import { Box, Button } from '@mui/material';

function DemoScan() {
  const [documentUrl, setDocumentUrl] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUrl = async () => {
      try {
        const url = await getDocumentUrl('Practitioner Partnership', 'public');
        setDocumentUrl(url);
      } catch (error) {
        console.error(error.message);
      }
    };
    fetchUrl();
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: 'column', width: '100%', gap: 2, marginTop: 4, alignItems: 'center', justifyContent: 'center' }}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => window.open(documentUrl, '_blank')}
      >
        Partnership Details 
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(`/videos/deep-dive`)}
      >
        What is Bioenergetic Testing
      </Button>
    </Box>
  );
}

export default DemoScan;